<template>
  <div :style="{ height: height, width: width, position: 'relative' }">
    <bar-chart
      :chart-data="datacollection"
      :options="chartOptions"
      :height="null"
      :width="null"
      style="height: 100%; width: 100%;"
    ></bar-chart>
  </div>
</template>

<script>
import { Bar, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

const BarChart = {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['options'],
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartData, this.options);
  }
}

export default {
  name: "BarChartJS",
  components: { BarChart },
  props: {
    datasource: { type: Object, default: () => ({ series: [], categories: [], colors: [] }) },
    height: { type: String, default: "100%" },
    width: { type: String, default: "100%" },
    titleChart: { type: String },
    titleChartColor: { type: String, default: "#000" },
    showLegend: { type: Boolean, default: false },
    chartStacked: { type: Boolean, default: false },
    columnWidth: { type: String, default: "80%" },
    yaxisShow: { type: Boolean, default: false },
    dataLabelsPercentValues: { type: Boolean, default: false },
    dataLabelsFontSize: { type: Number, default: 12 },
    xaxisLabelsFontSize: { type: Number, default: 12 }
  },
  computed: {
    datacollection() {
      return {
        labels: this.datasource.categories,
        datasets: this.datasource.series.map((item) => ({
          label: item.name || '',
          backgroundColor: this.datasource.colors || '#3498db',
          data: item.data
        }))
      }
    },
    chartOptions() {
        return {
            responsive: true,
            maintainAspectRatio: false,
            layout: {
                padding: {
                    top: 20,
                    bottom: 0,
                    left: 0,
                    right: 0
                }
            },
            title: {
                display: !!this.titleChart,
                text: this.titleChart,
                fontColor: this.titleChartColor,
                fontSize: 22,
                fontFamily: 'RobotoRegular',
                fontStyle: 'normal',
                padding: 20
            },
            scales: {
                xAxes: [{
                    stacked: this.chartStacked,
                    gridLines: {
                        display: true,          // Включаем, чтобы задействовать отрисовку
                        drawOnChartArea: false, // ЭТО ГЛАВНОЕ: скрывает сетку ВНУТРИ графика
                        drawTicks: true,        // Рисует маленькие "засечки" у цифр
                        drawBorder: true,       // Рисует основную линию оси
                        color: "#494f59"        // Цвет самой линии
                    },
                    categoryPercentage: 0.9, // Отступ между группами колонок
                    barPercentage: parseInt(this.columnWidth) / 100, // Конвертация "80%" в 0.8
                    ticks: {
                        fontSize: this.xaxisLabelsFontSize,
                        fontFamily: 'RobotoRegular',
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0
                    }
                }],
                yAxes: [{
                    stacked: this.chartStacked,
                    display: this.yaxisShow,
                    ticks: { 
                        beginAtZero: true,
                        fontFamily: 'RobotoRegular'
                    },
                    gridLines: { display: false }
                }]
            },
            tooltips: {
                enabled: true,
                callbacks: {
                    title: () => '',
                    label: (tooltipItem) => {
                        let value = tooltipItem.yLabel;
                        let displayValue = this.dataLabelsPercentValues ? value + '%' : value;
                        return ` ${tooltipItem.xLabel}: ${displayValue}`;
                    }
                }
            },
            plugins: {
                datalabels: {
                    // Рисуем только если showLabel включен И значение больше нуля
                    display: (ctx) => {
                        return ctx.dataset.data[ctx.dataIndex] > 0;
                    },
                    color: '#494f59', 
                    font: {
                        family: 'RobotoRegular',
                        size: this.dataLabelsFontSize,
                        weight: 'bold'
                    },
                    anchor: 'end',
                    align: 'top',
                    offset: 0,
                    formatter: (value) => {
                        return this.dataLabelsPercentValues ? value + '%' : value;
                    }
                }
            },
            legend: {
                display: this.showLegend,
                position: 'bottom',
                labels: {
                    usePointStyle: true, // Кружки вместо квадратов
                    padding: 20,
                    fontColor: '#494f59',
                    fontFamily: 'RobotoRegular',
                    fontSize: 12
                }
            }
        }
    }
  }
}
</script>